import React from "react";
import { Link } from "react-router-dom";
import useCounterAnimation from "../../hooks/useCounterAnimation";

const statCards = [
  {
    key: "contacts",
    className: "dashboard-stat-card--contacts",
    title: "Contact Requests",
    path: "/contact-form",
    linkLabel: "View contact requests",
    icon: "bx-envelope",
  },
  {
    key: "applications",
    className: "dashboard-stat-card--applications",
    title: "Career Applications",
    path: "/career-application",
    linkLabel: "View applications",
    icon: "bx-user-voice",
  },
  {
    key: "jobs",
    className: "dashboard-stat-card--jobs",
    title: "Jobs Posted",
    path: "/career",
    linkLabel: "View jobs",
    icon: "bx-briefcase",
  },
];

export const DashboardBasicDetails = ({
  totalContactRequests = 0,
  totalCareerApplications = 0,
  totalCareersPosted = 0,
}) => {
  const contactCount = useCounterAnimation(totalContactRequests, 1200);
  const applicationCount = useCounterAnimation(totalCareerApplications, 1200);
  const jobCount = useCounterAnimation(totalCareersPosted, 1200);

  const counts = {
    contacts: Math.round(contactCount),
    applications: Math.round(applicationCount),
    jobs: Math.round(jobCount),
  };

  return (
    <div className="row g-3">
      {statCards.map((card) => (
        <div className="col-xl-4 col-md-6" key={card.key}>
          <div className={`card card-animate dashboard-stat-card ${card.className}`}>
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="avatar-sm flex-shrink-0">
                  <span className="avatar-title rounded fs-3 dashboard-stat-icon">
                    <i className={`bx ${card.icon}`}></i>
                  </span>
                </div>
                <div className="flex-grow-1 ms-3 overflow-hidden">
                  <p className="text-uppercase text-truncate mb-1 dashboard-stat-label">
                    {card.title}
                  </p>
                  <h4 className="mb-2 dashboard-stat-count">
                    <span className="counter-value">{counts[card.key]}</span>
                  </h4>
                  <Link
                    to={card.path}
                    className="fw-medium text-decoration-none dashboard-stat-link"
                  >
                    {card.linkLabel}{" "}
                    <i className="ri-arrow-right-s-line align-middle"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardBasicDetails;
